import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableOrderNotes',
  initialState: false,
  reducers: {
    setEnableOrderNotes(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableOrderNotes } = slice.actions;

export default slice.reducer;
